import { PropsWithChildren, useMemo } from 'react';
import useStore from '../hooks/store/useStore';
import { REDUX_STORE_SLICES } from '../services/exports/Constants';
import useMobileApp from '../hooks/mobile-app/useMobileApp';
import DownloadMobileAppModal from '../modals/marketing/DownloadMobileAppModal';
import ReduxActions from '../store/ReduxActions';
import { actionCreators } from '../store/actions';
import useInitialData from '../hooks/global/useInitialData';
import useScreenType from '../hooks/utility/useScreenType';
import useStorefront from '../hooks/storefront/useStorefront';

const MarketingProvider = ({ children }: PropsWithChildren) => {
  const { isMobileApp } = useMobileApp();
  const { data, loading } = useInitialData();
  const { isStorefront } = useStorefront();
  const { franchise } = data;
  const { mobile_app } = useStore<REDUX_STORE_SLICES.MARKETING>(REDUX_STORE_SLICES.MARKETING);
  const { cookiesConsent } = useStore<REDUX_STORE_SLICES.APP_STATUS>(REDUX_STORE_SLICES.APP_STATUS);
  const { isDesktop } = useScreenType();

  const DownloadMobileApp = useMemo(() => {
    if (
      isMobileApp ||
      !franchise?.mobile_app?.released ||
      mobile_app?.download_modal_seen ||
      loading ||
      isDesktop ||
      cookiesConsent === undefined ||
      isStorefront
    ) {
      return null;
    }
    return (
      <DownloadMobileAppModal
        onClose={() => {
          ReduxActions.dispatch(
            actionCreators.marketing.updateMobileApp({
              download_modal_seen: true,
            }),
          );
        }}
      />
    );
  }, [
    isMobileApp,
    franchise?.mobile_app?.released,
    mobile_app?.download_modal_seen,
    loading,
    isDesktop,
    cookiesConsent,
    isStorefront,
  ]);
  return (
    <>
      {children}
      {DownloadMobileApp}
    </>
  );
};

export default MarketingProvider;
